import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { HelperService } from '../services/helper.service';
import { MatDialog } from '@angular/material/dialog';
import { LicenseExpiredModalComponent } from '../license-expired-modal/license-expired-modal.component';

@Injectable({
  providedIn: 'root'
})
export class LicenseGuard implements CanActivate {
  constructor(
    private helperService: HelperService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (state.url === '/dashboard/landing') {
      return true;
    }
    // Block access to all other routes if license is expired
    if (this.helperService.isLicenseExpired()) {
      // Show license expired modal
      this.dialog.open(LicenseExpiredModalComponent, {
        width: '400px',
        disableClose: true
      });
      return this.router.parseUrl('/dashboard/landing');
    }
    return true;
  }
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(route, state);
  }
}
